const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Articles} Articles the resource defined to manage Articles
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('scormHost', ['Access', 'Application', 'Authorization', 'ScormContent', 'ScormRegistrations', 'AdminAssignments', 'Users', '$translate', function(Access, Application, Authorization, ScormContent, ScormRegistrations, AdminAssignments, Users, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      template: require('../../templates/directives/scorm-host.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          var params = Application.navigation.getRouteParameters();
          self.contentId = params.id;
          self.chartData = {};
          self.userNames = {};
          self.activeTab = 'registrations';
          self.showSecrets = Application.showSecrets;
          self.downloadUrl = Application.API + "/learn/v3/scorm/download/" + self.contentId + "?authtoken=" + Access.getAuthtoken().authtoken;
          self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;
          self.stats = {
            total_registrations: 0,
            total_completed: 0,
            total_passed: 0,
            total_passed_completed: 0,
            time_series: [],
            time_average: 0,
            time_highest: 0,
            time_lowest: 0,
            score_series: [],
            score_average: 0,
            score_highest: 0,
            score_lowest: 0,
            score_unknown: 0,
            status_passed: 0,
            status_failed: 0,
            status_unkown: 0
          };
          $translate([
            'manage.host.chart_lastWeek',
            'manage.host.chart_lastMonth',
            'manage.host.chart_allTime',
            'scormHost.participants',
            'scormHost.registered_in_total',
            'scormHost.completed',
            'scormHost.completed_passed',
            'scormHost.total_completion',
            'scormHost.average_time',
            'scormHost.minutes_taken',
            'scormHost.passed',
            'scormHost.total_passed',
            'scormHost.failed',
            'scormHost.total_failed'
          ]).then(function(data) {
            self.translations = data;
            self.initialize();
          });

          self.usertoken = Authorization.getAuthToken();
          self.isAdmin = function() {
            if (self.usertoken.user.role === 'admin') {
              return true;
            } else {
              return false;
            }
          };

          self.contentType = 'scorm';


          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };


          self.getTitle = function() {
            return ScormContent.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise;
          };

          self.getStats = function() {
            return ScormRegistrations.stats({subresource: self.contentId}).$promise;
          };

          self.slimDate = function(date) {
            return moment(new Date(date)).format('D-MMM-YYYY h:mm a');
          };
          self.timeSpent = function(seconds_spent) {
            var seconds = parseInt(seconds_spent, 10);
            var mnts = Math.floor(seconds / 60);
            if (mnts > 0) {
              return mnts;
            }
            return (seconds / 60).toFixed(2);
          };
          self.resolveUsers = function() {
            if (self.usersResolved) {
              return;
            }
            self.usersResolved = true;
            var length = 0;
            var users = null;
            angular.forEach(self.modifications, function(mod) {
              var user = mod.user;
              if (!self.userNames[user]) {
                length++;
                if (!users) {
                  users = '' + user;
                  return;
                }
                users += ',' + user;
              }
            });
            return Users.find({
              fields: '_id,first_name,last_name,full_name,email,image,linked_departments,linked_locations',
              'linked_locations-populate': 'name',
              'linked_departments-populate': 'name',
              _id: '$in,' + length + ',' + users
            }).$promise.then(function(users) {
              angular.forEach(users, function(user) {
                self.userNames[user._id] = user;
              });
            });
          };

          self.showAssignments = function() {
            var assignmentFilter = {
              page: 1,
              per_page: 10
            };

            assignmentFilter['assigned_content.content_id'] = self.contentId;

            AdminAssignments.find(assignmentFilter).$promise.then(function(items) {
              if (items.length) {
                self.assignmentTab = true;
              }
            });
          };
          self.initialize = function() {
            if (!self.contentId || !self.contentType) {
              Application.navigation.goToHome();
              return;
            }

            self.initLoading = true;
            self.getTitle().then(function(item) {
              self.contentTitle = item.title;
              self.allowRating = item && item.rating_configuration && item.rating_configuration.allow_rating;
              if (item.average_rating) {
                var outOfFive = Math.round(item.average_rating * 5) / 100;
                if (outOfFive) {
                  self.rating = outOfFive;
                }
              }
            });
            self.getStats().then(function(stats) {
              self.stats = stats;
            });
            self.showAssignments();
          };
        }],
      controllerAs: 'host'
    };
  }]);
